import { HttpClient, HttpParams, HttpBackend, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';
import { PlacementAuthService } from '../placement-auth-service/placement-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AssistService {
  private httpPlacement: HttpClient;

  constructor(
    private http: HttpClient,
    private handler: HttpBackend,
    private placementAuthService: PlacementAuthService
  ) {
    this.httpPlacement = new HttpClient(handler);
  }

  getAssistList(queryParams?): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_ASSIST_LIST, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  getAssists(queryParams?: any): Observable<any> {
    const defaultParams = { size: 99999 };
    const params = new HttpParams({ fromObject: Object.assign(defaultParams, queryParams || {}) });
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.httpPlacement.get<any>(`${this.placementAuthService.baseUrl}/assists`, { headers, params });
      }),
      catchError(errorHandl)
    );
  }

  getAssistDetail(referenceId: string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.httpPlacement.get<any>(`${this.placementAuthService.baseUrl}/assists/${referenceId}`, { headers });
      }),
      catchError(errorHandl)
    );
  }


  getAllAssists(): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.GET_ASSIST_LIST, {})
      .pipe(
        catchError(errorHandl)
      );
  }

  createAssist(payload: any): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.httpPlacement.post<any>(`${this.placementAuthService.baseUrl}/assists`, payload, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getStates(): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.httpPlacement.get<any>(`${this.placementAuthService.baseUrl}/states`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getCities(): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.httpPlacement.get<any>(`${this.placementAuthService.baseUrl}/cities`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getFacilityTypes(): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.httpPlacement.get<any>(`${this.placementAuthService.baseUrl}/facilities/types`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getAccommodationTypes(): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.httpPlacement.get<any>(`${this.placementAuthService.baseUrl}/accommodations/types`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getZipcodesByCity(cityId: any): Observable<any> {
    const params = new HttpParams().set('city_id', String(cityId));
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.httpPlacement.get<any>(`${this.placementAuthService.baseUrl}/facilities/zipcode`, { headers, params });
      }),
      catchError(errorHandl)
    );
  }

  checkDuplicate(queryParams: any): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.httpPlacement.get<any>(`${this.placementAuthService.baseUrl}/assists/check-duplicate`, { headers, params });
      }),
      catchError(errorHandl)
    );
  }
}

